import * as Sentry from '@sentry/browser'
import { capitalize } from 'lodash'
import { getCurrentSearchParams } from 'src/helpers/browser'
import MikasaAdapter from './mikasaAdapter'
import NodeAdapter from './nodeAdapter'

const DEFAULT_SERVICE = 'node'
const ALLOWABLE_SERVICES = ['node', 'mikasa']

const adapters = {
  MikasaAdapter,
  NodeAdapter
}

class ApiSwitch {
  static fetch ({ action, service = DEFAULT_SERVICE, ...params } = {}) {
    let chosenService = getCurrentSearchParams()['hb-api-adapter'] || service

    if (!ALLOWABLE_SERVICES.includes(chosenService)) {
      Sentry.captureMessage(`Invalid service: ${chosenService}`)
      chosenService = DEFAULT_SERVICE
    }

    return new adapters[`${capitalize(chosenService)}Adapter`]().fetch({
      action,
      params
    })
  }
}

export default ApiSwitch
